<template>
  <booking-section id="travel-dates" :title="$t('booking.sectionTitles.datepicker')" contentClass="price-date-picker" :collapsed="moduleCollapsed" @section-clicked="sectionClicked">
    <div v-if="loaded">
      <div class="row">
        <div class="column small-12 large-6 large-order-2 hide-for-small-only hide-in-sales">
          <div class=" booking-element" :class="{'hide-for-small-only': packages.length == 0}">
            <div class="promotion__header">
              <img src="/images/diamond.svg"/>
              <div id="packages-list-preview" class="row" v-if="packages.length > 0">
                <h3 class="text-center">Aktuelle Luxury Dreams Packages</h3>
                <div class="package-details-wrapper" :ref="`package${pi}`" :id="`package${pi}`" v-for="(pack, pi) in packages">
                  <span v-html="pack"></span>
                  <div class="text-right"><a class="cta cta--secondary cta--small cta--inline" @click="showPackageDetails(`package${pi}`)">Details</a></div>
                </div>
              </div>
              <div v-html="info" class="hide-for-small-only"></div>
            </div>
          </div>
        </div>
        <div class="column small-12 large-6 large-order-1">
          <div class="booking-element" id="airport_selector">
            <div class="row">
              <div class="column small-12" v-if="productType != 'Kreuzfahrt'">
                <label>Abflughafen</label>
                <booking-element-error :type="errorType" :msg="'please_pick_flight_option'"></booking-element-error>
                <select2 v-model="booking.common.start_airports" :options="airportSelectValues" @change="reloadFlightPrices" :settings="{ placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow', multiple: true }" />
                <div  v-if="(booking.common.start_airports && !booking.common.start_airports.length) || (booking.common.start_airports == null && booking.common.start_airports != '-')">
                  <a class="cta cta--small cta--white" @click="disableFlight">Weiter ohne Flug</a>
                </div>
                <div v-else-if="booking.common.start_airports && booking.common.start_airports.length">
                  <input type="checkbox" id="nonStopFlightsOnly" v-model="booking.common.nonStopFlightsOnly">
                  <label for="nonStopFlightsOnly" class="control-label checkbox-label">Non-Stop Flüge bevorzugt?</label>
                </div>
              </div>
              <div class="column small-12" v-else>
                <label>Hinweis</label>
                <div>Für eine individuell an ihre Kreuzfahrt angepasste Flugauswahl wenden Sie sich bitte an unseren Kundenservice</div>
              </div>
            </div>
          </div>
          <div class="booking-element" id="fare_type_selector">
            <div class="row">
              <div class="column small-12">
                <label>Verpflegung</label>
              </div>
              <div class="column small-12">
                <booking-element-error :type="errorType" :msg="'please_pick_fare_type'"></booking-element-error>
                <select2 v-model="booking.common.fare_type_id" :options="fareTypeSelectValues" :settings="dropdownOpts" />
              </div>

            </div>
          </div>

          <div :class="`airport_selector booking-element booking-room-setup-container ${!personSetupValid ? 'booking-error' : ''}`" id="travellingPersons" v-for="(setup,i) in booking.setups">
            <div class="row">
              <div class="column small-12">
                <label>{{ i+1 }}. Zimmer Belegung </label>
              </div>
            </div>

            <div class="row" >
                <div class="column small-12 medium-6 text-right" v-for="personType in ['adult', 'kid']">
                  <!-- <a :class="`cta cta--small ${(personsInRoom(i, personType).length > 0) ? '' : 'cta--white' } cta--inline`" @click="removePerson(i, personType)">-</a>
                  <input class="underline text-center" type="text" readonly :value="personsInRoom(i, personType).length"></input>
                  <a :class="`cta cta--small ${(personsInRoom(i, personType).length < max_persons[personType]) ? '' : 'cta--white' } cta--inline`" @click="addPerson(i, personType)">+</a> -->
                  <select2 :value="personsInRoom(i, personType).length" :ref="`${personType}${i}`" :options="paxDropdownValues[personType]" :settings="dropdownOptsMin" @change="adjustPersons(i, personType)" />
                </div>
            </div>
            <div class="row" v-if="personsInRoom(i, 'kid').length > 0">
              <div class="column medium-12 small-12"><label>Geburtsdaten Kinder</label></div>
              <div class="column medium-4 small-12" v-for="(kid, ki) in personsInRoom(i, 'kid')"><input class="underline" type="text" v-model="kid.date_of_birth" placeholder="TT.MM.JJJJ"></input></div>
            </div>

            <div class="row" v-if="!personSetupValid && personErrorMessage[i] != ''">
              <div class="column small-12">
                <booking-element-error :type="errorType" :msg="personErrorMessage[i]"></booking-element-error>
              </div>
            </div>

            <div class="row room-setup-controls">
              <div class="column small-12">
                <a class="cta cta--inverse cta--inline" @click="addRoom()">Zimmer hinzuf.</a>
                <a class="cta cta--dark cta--inline" @click="removeRoom(i)" v-if="i > 0">Entf.</a>
              </div>
            </div>
          </div>



        </div>
      </div>

      <div class="row align-center small-collapse medium-uncollapse">
        <div class="column small-12">
          <div :class="`booking-element ${twoDaysSelected ? 'dates-picked' : ''}`" id="travel_dates_select">
            <flat-pickr v-if="loaded && datepickerReady" v-model="booking.dates" :config="datePickerConfig"></flat-pickr>
            <loader v-else title="Daten werden geladen" details="Einen Moment bitte"></loader>

            <p class="text-center small hide-for-small-only">
              Die angegebenen Preise zeigen den tagesaktuellen Übernachtungspreis pro Person/Nacht – bei der Berechnung des Gesamtreisepreises werden sowohl vorhandene Sonderpreise als auch ggf. zusätzliche Benefits berücksichtigt.
            </p>
            <p class="text-center small hide-for-small-only" v-if="package_settings.min_days">
              Die markierten Termine zeigen neben dem tagesaktuellem Übernachtungspreis pro Person/Nacht beispielhaft auch den
              Paketpreis für {{package_settings.min_days}} Nächte mit Flug, an denen LUXURY DREAMS Kunden exklusive Preis- und Leistungsvorteile erhalten.
            </p>
            <p class="text-center small hide-for-small-only" v-if="package_settings.offset && package_settings.offset != 0">
              Bitte beachten Sie, dass die Ankunft in dieser Destinationen erst einen Tag nach Abreise erfolgt und Sie das Rückflugdatum entsprechend {{package_settings.min_days+package_settings.offset}} Nächte später auswählen. Bei Auswahl einer längeren Aufenthaltsdauer werden selbstverständlich die Preis- und Leistungsvorteile innerhalb des Aktionszeitraumes berücksichtigt.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column small-12">
          <div class="text-right booking-element"  v-if="dataReadyForCalculation">
            <a class="cta" @click="loadResults">Verfügbare Zimmer anzeigen</a>
          </div>
          <div class="booking-element booking-error" v-else>
            <booking-element-error :msg="'min_stays_hint'" :msgOptions="minStayOptions" v-if="minStayOptions.stays > 0"></booking-element-error>
            <booking-element-error type="error" v-else="currentStatusInfo" :msg="currentStatusInfo"></booking-element-error>
          </div>
        </div>
        <div v-if="vp_enabled" class="column small-12 ">
          <div v-if="partnerCodeValid" class="row">
            <div class="column small-4">
              <img :src="current_vp.logo_url" />
            </div>
            <div class="column small-8">
              <b>Aktiver Partner: {{ current_vp.name }}</b>
              <br />
              {{ current_vp.contact_name }}
            </div>
          </div>
          <div v-else-if="admin" class="row hide-in-sales">
            <div class="column small-8">
              <b>ADMIN-Modus: VP-Code eingeben</b>
              <br />
              <input type="text" v-model="booking.common.vp_code">
            </div>
          </div>

        </div>
      </div>

    </div>
    <loader v-else title="Buchungsvorgang wird gestartet" details="Einen Moment bitte"></loader>
    <div id="package-details-overlay" class="reveal" data-reveal="">
      <div class="inner"></div>
      <button class="close-button" aria-label="Popup schließen" data-close="" type="button">Fenster schließen ( x )</button>
    </div>
  </booking-section>


</template>

<script>

import flatPickr from 'vue-flatpickr-component'
import { German } from 'flatpickr/dist/l10n/de.js'
import bookingDefaults from '../booking/mixins/bookingDefaults'
import axios from 'axios'

export default {
  props: ['productId'],
  mixins: [bookingDefaults],
  data: function () {
    return {
      prices: {},
      promotions: {},
      airports: [],
      fare_types: [],
      loaded: false,
      includeFlight: false,
      datepickerReady: false,
      propductType: null,
      booking: {
        common: {
          start_airports: null,
          travel_from: null,
          travel_to: null,
          fare_type_id: null,
          vp_code: null,
        },
        dates: null,
        setups: [
          {
            person_1: { type: 'adult'},
            person_2: { type: 'adult'}
          }
        ]

      },
      paxDropdownValues: {
        adult: [

        ],
        kid: [
          { id: 0, text: "keine Kinder" },

        ]
      },
      package_settings: {},
      packages: [],
      personErrorMessage: [],
      minStayOptions: { stays: 0 },
      min_stays: [],
      currentStep: 'datepicker',
      errorType: 'hint',
      failedAttempts: 0,
      vp_enabled: false,
      show_vp_code: false,
      admin: false,
      current_vp: {
        id: null, code: null
      },
      dropdownOpts: { placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow' },
      dropdownOptsMin: { placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow', minimumResultsForSearch: Infinity }
    }
  },
  components: {
    flatPickr
  },
  watch: {
    'booking': {
      handler(val){
        localStorage.setItem(this.currentBookingStorageKey, JSON.stringify(val))
        this.personSetupValid
      },
      deep: true
    },
    'includeFlight': {
      handler(val){
        this.loadPackageFlights()
      }
    },
    'vp_enabled': {
      handler(val){
        window.vp_enabled = val
      }
    }
  },
  mounted(){
    axios.get(this.apiUrl('init'))
        .then(response => {
          this.prices = response.data.prices
          this.airports = response.data.airports
          this.max_persons = { adult: response.data.max_adults, kid: response.data.max_kids }
          this.fare_types = response.data.fare_types
          this.booking.common.fare_type_id = null
          this.info = response.data.info
          this.min_stays = response.data.min_stays
          this.package_settings = response.data.package_settings
          this.packages = response.data.packages
          this.vp_enabled = response.data.vp_enabled
          this.productType = response.data.product_type
          
          
          if (this.productType == "Kreuzfahrt"){
            this.disableFlight()
          }

          this.admin = response.data.admin

          this.gTrack('init')

          this.loaded = true
          this.datepickerReady = true
          this.assignDataFromSearchQuery()

          Array.from(Array(response.data.max_adults)).forEach((a,i) => {
            this.paxDropdownValues.adult.push({
              id: i+1, text: `${i+1} Erwachsene(r)`
            })
          })

          Array.from(Array(response.data.max_kids)).forEach((a,i) => {
            this.paxDropdownValues.kid.push({
              id: i+1, text: `${i+1} Kind(er)`
            })
          })


          const cur = localStorage.getItem(this.currentBookingStorageKey)
          if (cur != null){
            this.booking = JSON.parse(cur)
            this.assignDataFromSearchQuery()
            if (this._.includes(this.booking.common.start_airports, '-') || this.booking.common.start_airports.length == 0){
              this.booking.common.start_airports = ['-']
              this.includeFlight = false
            }else{
              this.includeFlight = true
            }
          }
          
          // assign VP at last to make sure its not blocked by caching
          if (this.vp_enabled){
            this.current_vp = response.data.current_vp
            this.booking.common.vp_code = this.current_vp.code
          }
        })
        .catch(e => {  console.log(e) })
  },
  computed: {
    withFlight(){
      return (this.includeFlight && (this.booking.common.start_airports.length > 0 && this.booking.common.start_airports != ['-']))
    },
    airportSelectValues(){
      return this._.concat(
        [
          {id: '-', text: "- Ohne Flug - "},
          {id: null, text: "oder wählen Sie Ihren gewünschten Startflughafen:"}
        ],
        this.airports
      )
    },
    twoDaysSelected(){
      return this.booking.dates && this.booking.dates.match(/[0-9]{4}\-[0-9]{2}\-[0-9]{2}[a-z\ ]{1,}[0-9]{4}\-[0-9]{2}/)
    },
    showMultiMonth(){
      return $(window).width() >= 1040
    },
    fareTypeSelectValues(){
      return this._.concat(
        [
          {id: null, text: "Bitte wählen"},
        ],
        this.fare_types
      )
    },
    dataReadyForCalculation(){
      return (this.travelDatesSelected &&
        this.fareTypeSelected &&
        this.startAirportSelected &&
        this.personSetupValid &&
        this.minStaysFulfilled
      )
    },
    currentStatusInfo(){
      if (!this.startAirportSelected){
        return 'please_pick_flight_option'
      }else if (!this.fareTypeSelected){
        return 'please_pick_fare_type'
      }else if (!this.personSetupValid){
        return 'please_check_travelling_persons'
      }else if (!this.travelDatesSelected){
        return 'please_pick_travel_dates'
      }
    },
    personSetupValid(){
      if (!this.fareTypeSelected) return true
      let status = true
      this.booking.setups.forEach((s,i) => {
        this.personErrorMessage[i] = ''
        if (this.personsInRoom(i, 'adult').length == 0){
          status = false
          this.personErrorMessage[i] = 'min_one_adult'
        }

        this.personsInRoom(i, 'kid').forEach(k => {
          if (k.date_of_birth != null){
            var date = `${k.date_of_birth.split('.')[2]}-${k.date_of_birth.split('.')[1]}-${k.date_of_birth.split('.')[0]}`
            if (!(k.date_of_birth.match(/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/)) || new Date(date) == 'Invalid Date' || k == null || k.date_of_birth == '' || k.date_of_birth == null){
              status = false
              this.personErrorMessage[i] = 'please_check_date_of_birth'
            }else if (k.date_of_birth != null && (this.isDate(k.date_of_birth)) && this.getAge(k.date_of_birth) > 17){
              k.type = 'adult'
            }
          } else {
            status = false
          }

        })
      })
      return status
    },
    startAirportSelected(){
      return this.booking.common.start_airports != null
    },
    fareTypeSelected(){
      return this.booking.common.fare_type_id != null
    },
    travelDatesSelected(){
      return (this.booking.common.travel_from != null && this.booking.common.travel_to != null) && this.twoDaysSelected != null
    },
    minStaysFulfilled(){
      var status = true
      this.minStayOptions = { stays: 0 }
      if (this.travelDatesSelected){
        const days = this.currentlyBookedDays
        const tFrom = new Date(this.booking.common.travel_from);
        const tTo = new Date(this.booking.common.travel_to);
        this.min_stays.forEach(stay => {
          const sFrom = new Date(stay.from)
          const sTo = new Date(stay.to)

          if (((tFrom >= sFrom && tFrom <= sTo) || (tTo >= sFrom && tTo <= sTo)) && days < stay.n){
            status = false
            this.minStayOptions = {
              from: sFrom.toLocaleDateString(),
              to: sTo.toLocaleDateString(),
              stays: stay.n
            }
          }
        })
      }
      return status
    },
    currentlyBookedDays(){
      if (this.travelDatesSelected){
        var date1 = new Date(this.booking.common.travel_from);
        var date2 = new Date(this.booking.common.travel_to);

        // To calculate the time difference of two dates
        var Difference_In_Time = date2.getTime() - date1.getTime();

        // To calculate the no. of days between two dates
        return Difference_In_Time / (1000 * 3600 * 24);
      }else{
        return 0
      }
    },
    datePickerConfig() {
      return {
        minDate:    new Date(Object.keys(this.prices)[0]),
        inline:     true,
        altInput:   true,
        altFormat:  "d. F Y",
        locale:     German,
        mode:       "range",
        showMonths: (this.showMultiMonth ? 2 : 1),
        disableMobile: true,
        onReady: (selectedDates, dateStr, instance) => {
          $(instance.calendarContainer).addClass("color");
        },
        onDayCreate: (dObj, dStr, instance, dayElem) => {
          var currDay = dayElem.dateObj
          var currDayString = currDay.toISOString()
          if (this.promotions[currDayString]) { $(dayElem).addClass("has-promotion") }
          if (this.prices[currDayString]) {
            $(dayElem).append('<div class="flatpickr-price">' + this.prices[currDayString] + '€ </div>');
          }
          if (this.promotions[currDayString]) {
            $(dayElem).append('<div class="flatpickr-price promotion-price">' + parseInt(this.promotions[currDayString].price) + '.' + this.promotions[currDayString].airport + '</div>');
          }
        },
        onChange: (selectedDates, dateStr, instance) => {
          var startDate = selectedDates[0]

          if (selectedDates.length == 2){
            this.gTrack('datesSelected', selectedDates)
          }


          if (selectedDates[1]) {
            var endDate       = selectedDates[1]
            this.booking.common.travel_from = startDate.toISOString()
            this.booking.common.travel_to = endDate.toISOString()
            this.errorType = 'error'

            if (!this.minStaysFulfilled){
              this.addErrorForElement('travel_dates_select')
            }else {
              this.removeErrorForElement('travel_dates_select')
            }
          }else if (!this.twoDaysSelected && this.promotions[startDate.toISOString()]) {
            // setting end date
            var start = startDate.toISOString()
            var result = startDate
            result.setDate(startDate.getDate() + (this.package_settings.min_days + this.package_settings.offset))
            instance.setDate(`${start} bis ${result.toISOString()}`)
            this.booking.common.travel_from = start
            this.booking.common.travel_to = result.toISOString()

          }
        },
        enable: [
          (date) => { return this.prices[date.toISOString()] }
        ]
      }
    },
    partnerCodeValid(){
      return this.current_vp.id != null
    },
    currentBookingStorageKey(){
      return `lxd:currentBookingV1.1:${this.productId}`
    }
  },
  methods: {
    personsInRoom(i, type){
      var persons = []
      Object.keys(this.booking.setups[i]).forEach(pers => {
        if (this.booking.setups[i][pers].type == type){
          persons.push(this.booking.setups[i][pers])
        }
      })
      return persons
    },
    addRoom(){
      this.booking.setups.push({})
    },
    removeRoom(i){
      this.booking.setups.splice(i,1)
    },
    reloadFlightPrices(val){
      if (!this.booking.common.start_airports.length){
        this.includeFlight = false
      } else if (this._.includes(val, '-')){
        this.includeFlight = false
        this.booking.common.start_airports = ['-']
      }else {
        this.booking.common.start_airports = val.filter(a => {
          return (a != '-')
        })
        this.includeFlight = true
      }
      this.loadPackageFlights()
      if (this.booking.common.start_airports.length){
        this.gTrack('flightModeChanged', this.booking.common.start_airports)
      }

      this.$emit('flight-mode-changed', this.includeFlight)

      if (val.length){
        this.removeErrorForElement('airport_selector')
      }
    },
    loadPackageFlights(){
      this.datepickerReady = false
      axios.get(this.apiUrl('package_days'), {params: { airport_codes: this.booking.common.start_airports }})
        .then(response => {
          this.promotions = response.data
          this.datepickerReady = true
        })
    },
    adjustPersons(i, personType){
      var currentVal = parseInt(this.$refs[`${personType}${i}`][0].select2.val())
      var dataVal = this.personsInRoom(i, personType).length

      var personDiff = currentVal - dataVal
      console.log(personDiff)
      this.gTrack('adjustPersons', `${i}-${personType}`, currentVal)

      if (personDiff != 0){
        if (personDiff > 0){
          for(let pi = 0; pi < personDiff; pi++){
            console.log("add person")
            this.addPerson(i,personType);
          }
        }else if (personDiff < 0){
          for(let pi = 0; pi > personDiff; pi--){
            console.log("remove person")
            this.removePerson(i,personType);
          }
      }
    }

      console.log(event, i, personType)
    },
    addPerson(i, type){
      if (this.personsInRoom(i, type).length < this.max_persons[type]){
        // getting max person key for adding additional data
        if (Object.keys(this.booking.setups[i]).length == 0){
          var c = 1
        }else {
          var c = Math.max(...this._.map(Object.keys(this.booking.setups[i]), (e) => { return parseInt(e.split('_')[1]) } ))
        }

        let current = this.booking.setups
        current[i][`person_${c+1}`] = { type: type, date_of_birth: null }
        this.booking.setups = this._.cloneDeep(current)
      }
    },
    removePerson(i,type){
      let current = this.booking.setups
      // find first entry for given type
      const pi = Object.values(current[i]).findIndex(e => e.type == type)
      if (pi != -1){
        current[i] = _.omit(current[i], Object.keys(current[i])[pi] )
        this.booking.setups = this._.cloneDeep(current)
      }

    },
    getAge(DOB) {
      var today = new Date();
      var birthDate = new Date(DOB);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age = age - 1;
      }

      return age;
    },
    isDate(str){
      return (str.match(/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/) || str.match(/[0-9]{8}/))
    },
    assignDataFromSearchQuery(){
      if (window.searchQueryJson){
        if (window.searchQueryJson.from && window.searchQueryJson.to){
          this.booking.common.travel_from = window.searchQueryJson.from
          this.booking.common.travel_to = window.searchQueryJson.to
          this.booking.dates = `${this.booking.common.travel_from} bis ${this.booking.common.travel_to}`
        }
      }
    },
    loadResults(init = true){
      if (this.dataReadyForCalculation){
        this.gTrackProceed()
        this.resetElementErrors()
        $("body").addClass('bookingActive')
        this.$emit('next-started')
        axios.get(this.apiUrl('preload_rooms'), { params: { calculationData: JSON.stringify(this.booking), init: init, flight: this.withFlight } })
        .then(response => {
          
          if (response.data.global.status == "NOK"){
            this.showGlobalErrorMessage(response.data.global.errors)
            this.$emit('failed')
          }else{
            this.$emit('enable-sidebar')
            this.$emit('next-loaded', response.data)
          }
          
          
        })
        .catch(error => {
          console.log(error);
          if (this.failedAttempts < 3){
            this.failedAttempts++
            this.loadResults()
          }else {
            this.$emit('failed')
          }
        })
      }else {
        // checking all missig params to guid the user
        if (!this.startAirportSelected){
          this.addErrorForElement('airport_selector')
        }else if (!this.fareTypeSelected){
          this.addErrorForElement('fare_type_selector')
        }else if (!this.personSetupValid){
          this.addErrorForElement('travellingPersons')
        }else if (!this.travelDatesSelected){
          this.addErrorForElement('travel_dates_select')
        }else if (!this.minStaysFulfilled){
          this.addErrorForElement('travel_dates_select')
        }
      }
    },
    disableFlight(){
      this.booking.common.start_airports = ["-"]
      this.gTrack('disableFlight')
      this.includeFlight = false
    },
    showPackageDetails(packRef){
      var packageDetails = new Foundation.Reveal($("#package-details-overlay"))
      const data = $(this.$refs[packRef][0]).find(".detail__description").html()
      $("#package-details-overlay .inner").html(data)
      this.gTrack('showPackageDetails')
      packageDetails.open()
    },
    showVpCode(){
      this.show_vp_code = true
    },
    checkPartnerCode(val){
      const v = val.currentTarget.value
      if (v && v.length){
        axios.get(this.apiUrl('partner_status'), {params: { code: val.currentTarget.value }})
        .then(res => {

          if (res.data.status == 'OK'){
            this.current_vp = res.data.vp
            this.vp_enabled = true
            this.booking.common.vp_code = this.current_vp.code
          }else {
            this.show_vp_code = false
            this.vp_enabled = false
            this.$alert("Es wurde leider kein passender Eintrag für ihr VP-Nummer zu diesem Produkt gefunden")
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>